import { getContext, setContext } from "svelte";
import { writable, type Writable } from "svelte/store";

type TimeZone = string;

interface Time extends Writable<Date> {
  override: boolean;
}

/**
 * Returns a writable subscription to the system clock.
 */
export function getNow(): Time {
  return getContext("now$");
}

export function setNow(value: Date) {
  const time = getNow();

  if (time) {
    if (time.override != true) {
      time.set(value);
    }
  } else {
    setContext("now$", writable(value));
  }
}

/**
 * Returns a writable subscription to the current facility's timezone
 */
export function getTimeZone(): Writable<TimeZone> {
  return getContext("timeZone$");
}

export function setTimeZone(value: TimeZone) {
  const timeZone = getTimeZone();

  if (timeZone) {
    timeZone.set(value);
  } else {
    setContext("timeZone$", writable(value));
  }
}
